function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.064,
    height: 64.041,
    viewBox: "0 0 101.064 64.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tbkgertk1a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13",
    style: {
      fill: "#fff"
    },
    d: "M0 0h47.003v93.819H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 11"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 10",
    transform: "rotate(-101 30.88 28.324)",
    style: {
      clipPath: "url(#tbkgertk1a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 22",
    d: "M31.384 1.972A40.482 40.482 0 0 1 44.227 0 2.644 2.644 0 0 1 47 2.627a2.585 2.585 0 0 1-2.617 2.668c-.894.07-1.791.118-2.658.164a34.609 34.609 0 0 0-13.116 3.25C15.023 15.184 7.3 25.91 5.654 40.589a36.151 36.151 0 0 0 7.606 27.2 92.17 92.17 0 0 0 7.34 7.981c1.139 1.145 2.317 2.328 3.44 3.514.32.338.63.684.94 1.03l.438.487a.622.622 0 0 0 1.027-.159 1.511 1.511 0 0 0 .167-1.421c-.372-1.613-.73-3.229-1.1-4.843-.777-3.419-1.579-6.955-2.335-10.438a2.507 2.507 0 0 1 1.853-2.95 2.427 2.427 0 0 1 1.975.173 3.476 3.476 0 0 1 1.5 2.323l.091.4c1.977 8.7 4.022 17.69 6.046 26.533a2.8 2.8 0 0 1-.721 2.631 2.636 2.636 0 0 1-2.507.694q-10.068-2.316-20.132-4.649L4.394 87.5a3.373 3.373 0 0 1-2.05-1.238 2.458 2.458 0 0 1-.358-2.04c.373-1.613 1.747-2.356 3.588-1.944 1.447.326 2.892.663 4.336 1q1.559.365 3.121.725 2.725.625 5.453 1.238l2.452.555a.623.623 0 0 0 .679-.3l.141-.249a.622.622 0 0 0-.087-.731l-.238-.256c-.18-.2-.36-.391-.548-.579q-1.249-1.257-2.508-2.5a333.84 333.84 0 0 1-5.119-5.17C1.329 63.607-2.576 49.153 1.648 33.047 5.678 17.685 15.683 7.23 31.384 1.972",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrow);
export default __webpack_public_path__ + "static/media/card-arrow.087d945cd4f179b66419ce71d139d79a.svg";
export { ForwardRef as ReactComponent };